module.exports = __webpack_public_path__ + "img/forum-events-16.dc11c3f3.png";